export enum SignType {
	CallCenter,
	Web,
}
